export const SEMANTIC_UI_SIZE = {
    MINI: "mini",
    TINY: "tiny",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    BIG: "big",
    HUGE: "huge",
    MASSIVE: "massive",
}
